export * from './Consultation'
export * from './Patient'
export * from './Consultant'
